import { display, width } from "@mui/system";
import React, { useState, useRef, useEffect } from "react";
import { View, Text, StyleSheet, ScrollView, SafeAreaView, ActivityIndicator, Modal, Pressable, TouchableOpacity } from "react-native";
import { Button, Picker, SectionList } from "react-native-web";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Icon from 'react-native-vector-icons/FontAwesome';
import { ComponentToPrint } from "../Components/ComponentToPrint";
import ReactToPrint from 'react-to-print';
import { useTranslation } from 'react-i18next';
import { i18n } from './../assets/lang/i18next';
import ScrollToTop from "react-scroll-to-top";

const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: 'red',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const ResultBorodatiSimple = props => {
    const { t, i18n } = useTranslation();
    const componentRef = useRef();
    const classes = useStyles();
    const [modalVisible, setModalVisible] = useState(false);
    const [errorlist, SetErrorList] = useState("");
    let damayotagh = props.route.params.DAMAYOTAGH;
    let damayout = props.route.params.DAMAYOUT;
    let shadat = (props.route.params.SHEDAT == '1' ? t('normal') : props.route.params.SHEDAT == '0.5' ? t('light') : props.route.params.SHEDAT == '1.5' ? t('heavy') : null);
    let zamansystem = props.route.params.ZAMANSYSTEM;
    let tol = props.route.params.TOL;
    let arz = props.route.params.ARZ;
    let ertefa = props.route.params.ERTEFA;
    let ayegh = (props.route.params.AYEGH == t('polyurethane') || props.route.params.AYEGH == "0.018" ? t('polyurethane') : t('polystyrene'));
    let zekhamatdivar = props.route.params.ZEKHAMATDIVAR;
    let zekhamatkaf = props.route.params.ZEKHAMATKAF;
    let zaribhadayatayegh = props.route.params.ZARIBHADAYATAYEGH;
    let tavanfan = props.route.params.TAVANFAN;
    let roshanaei = props.route.params.ROSHANAIE;
    let tedadkatgar = props.route.params.TEDADKARGAR;
    let liftrag = props.route.params.LIFTRAG;
    let zarfiyatbargiri = props.route.params.ZARFIYATBARGIRI;
    let zarfiyatbargirirozaneh;
    if (props.route.params.KARBARIID == 5) {
        tavanfan = 0;
        roshanaei = 0;
        tedadkatgar = 0;
        liftrag = 0;
    }
    if (props.route.params.ZARFIYATBARGIRIROZANEH != "" && props.route.params.ZARFIYATBARGIRIROZANEH != null)
        zarfiyatbargirirozaneh = props.route.params.ZARFIYATBARGIRIROZANEH;
    else
        zarfiyatbargirirozaneh = (parseFloat(zarfiyatbargiri) < parseFloat(150000)) ?
            (Math.round(zarfiyatbargiri * 0.1))
            : (parseFloat(zarfiyatbargiri) >= parseFloat(150000) && parseFloat(zarfiyatbargiri) < parseFloat(250000)) ?
                15000
                : (parseFloat(zarfiyatbargiri) >= parseFloat(250000) && parseFloat(zarfiyatbargiri) < parseFloat(350000)) ?
                    17500
                    : (parseFloat(zarfiyatbargiri) >= 350000 && parseFloat(zarfiyatbargiri) < 450000) ?
                        20000
                        : (parseFloat(zarfiyatbargiri) >= parseFloat(450000) && parseFloat(zarfiyatbargiri) < parseFloat(550000)) ?
                            25000
                            : (parseFloat(zarfiyatbargiri) >= parseFloat(550000)) ?
                                (Math.round(parseFloat(zarfiyatbargiri) * 0.05)) :
                                "خطا";;




    let damayvorodi = props.route.params.DAMAYVORODI;
    let zamansardsazi = props.route.params.ZAMANSARDSAZI;
    let mahsol = props.route.params.KARBARI;
    let talafatjedareha = props.route.params.TALAFATJEDAREHA;
    let talafathava = props.route.params.TALAFATHAVA;
    let mabaghihararati = props.route.params.MABAGHIHARARATI;
    if (props.route.params.KARBARIID == 5) {
        tavanfan = 0;
        roshanaei = 0;
        tedadkatgar = 0;
        liftrag = 0;
        mabaghihararati = 0;
        zarfiyatbargirirozaneh = zarfiyatbargiri;
    }


    let barsardsazi = props.route.params.BARSARDSAZI;
    let bartanafosi = props.route.params.BARTANAFOSI;
    let qn = props.route.params.QN;
    let te = props.route.params.TE;
    let tc = props.route.params.TC;

    const [mobared, setMobared] = useState(0);
    const [itemsMobaredTemp, setMobaredTempItems] = useState([]);
    const [zarfiyatevaprator, setZarfiyatevaprator] = useState(0);
    const [brand, setBrand] = useState(1);
    const [selectcompresor, setSelectCompresor] = useState("0");
    const [selectcompanyevaprator, setSelectCompanyEvaprator] = useState("-");
    const [dataevap, setEvapData] = useState(() => { item => setEvapData(item) });
    const [itemsEvapTemp, setEvapTempItems] = useState([]);
    const [zarfiyatnami, setZarfiyatnami] = useState("-");
    const [txttedadevaprator, SetTxtTedadEvaprator] = useState("1");
    const [txtlabelevaprator, SetTxtLabelEvaprator] = useState("");
    const [selectcompanycond, setSelectCompanyCond] = useState("-");
    const [datacond, setCondData] = useState(() => { item => setCondData(item) });
    const [itemsCondTemp, setCondTempItems] = useState([]);
    const [zarfiyatnamicond, setZarfiyatnamicond] = useState("-");
    const [sellabelcondonsor, setSelLabelCondonsor] = useState("-");
    const [txtzarfiyatcondonsor, setTxtzarfiyatcondonsor] = useState("-");
    const [inprogsess, setInprogress] = useState(false);
    const [zaribetminancomprosor, Setzaribetminancomprosor] = useState("-");
    const [zaribetminancondonsor, Setzaribetminancondonsor] = useState("-");

    let fc = 0;
    let qn_1 = 0;
    let localQN = 0;


    function GetMobared(parambrand, parammobared) {

        setZarfiyatevaprator("-");
        fetch(`https://app.arshehkar.com/query/public/GetCompList.php?te=${te}&tc=${tc}&brand=${parambrand}&model=${parammobared}&q=${qn}`)
            .then(response => response.json())
            .then(async (datamobared) => {
                const mapArray = datamobared.map(({ model, ans }) => ({ label: model, value: ans }));
                setMobaredTempItems(mapArray);
                if (datamobared.length > 0) {
                    setZarfiyatevaprator(datamobared[0]["ans"]);
                    setSelectCompresor(datamobared[0]["model"]);

                    mohasebeQN(datamobared[0]["ans"], mobared, txttedadevaprator); GetListEvaprator(selectcompanyevaprator, txttedadevaprator);
                    GetZarfiyatCondonsor(datamobared[0]["model"], parammobared);
                    Setzaribetminancomprosor((datamobared[0]["ans"] / qn).toFixed(2));
                }
                else {
                    setZarfiyatevaprator("-");
                    setSelectCompresor("-");
                    GetZarfiyatCondonsor("-", "-");
                    //  setCondData(null);
                    setZarfiyatnamicond("-");
                    //setCondTempItems(null);
                    setTxtzarfiyatcondonsor("-");
                    Setzaribetminancomprosor("-");

                }

            })



    }

    function GetListEvaprator(selbnd, teevap) {
        if (selbnd != 0 && selbnd!="" && selbnd!="-" &&  zarfiyatevaprator != 0 && zarfiyatevaprator != "-" && zarfiyatevaprator != "" && mobared != "" && mobared != "-" && mobared != 0 && selectcompresor != "-" && selectcompresor != "" && selectcompresor != 0) {

            if (selbnd != "0") {
                mohasebeQN(zarfiyatevaprator, mobared, teevap);
                fetch(`https://app.arshehkar.com/query/public/GetListEvaprator.php?qn=${localQN}&cmp=${selbnd}&totagh=${damayotagh}`)
                    .then(response => response.json())
                    .then(async (dataevap) => {
                        const mapArray = dataevap.map(({ model_title, zarfiyatnami }) => ({ label: model_title, value: zarfiyatnami }));
                        setEvapTempItems(mapArray);
                        if (dataevap.length > 0) {
                            setZarfiyatnami(dataevap[0]["zarfiyatnami"])
                            SetTxtLabelEvaprator(dataevap[0]["model_title"]);
                        }
                        else
                            setZarfiyatnami("-");
                        mohasebeQN(zarfiyatevaprator, mobared, teevap);
                    })
            }
            else {
                setEvapData(null);
                setEvapTempItems(null);
                setZarfiyatnami("-");
            }
        }
        else {
            setEvapData(null);
            setZarfiyatnami("-");
            setEvapTempItems([]);
        }

    }
    function mohasebeQN(ze, mo, tee) {
        switch (damayotagh - parseFloat(te)) {
            case 5:
                fc = (0.7109825 + (0.02437231 * (te)) + (0.001258625 * (Math.pow(te, 2))) + (0.00003948019 * (Math.pow(te, 3))) + (0.0000006536131 * (Math.pow(te, 4))) + (0.000000004307692 * (Math.pow(te, 5))));
                break;
            case 6:
                fc = (0.8709434 + (0.03498631 * (te)) + (0.002442587 * (Math.pow(te, 2)) + (0.00009775781 * (Math.pow(te, 3))) + (0.000001914033 * (Math.pow(te, 4))) + (0.00000001421538 * (Math.pow(te, 5)))));
                break;
            case 7:
                fc = (1.050832 + (0.03611483 * (te)) + (0.00191451 * (Math.pow(te, 2))) + (0.0000595303 * (Math.pow(te, 3))) + (0.0000009655012 * (Math.pow(te, 4))) + (0.00000000625641 * (Math.pow(te, 5))));
                break;
            case 8:
                fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                break;
            case 9:
                fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                break;
            case 10:
                fc = (1.604168 + (0.06317434 * te) + (0.00436317 * (Math.pow(te, 2))) + (0.0001764953 * (Math.pow(te, 3))) + (0.00000357296 * (Math.pow(te, 4))) + (0.00000002758974 * (Math.pow(te, 5))));
                break;
            case 10:
                break;


        }
        qn_1 = parseFloat(ze) / parseFloat(parseFloat(tee) * fc);
        if (mo == "R22") {
            localQN = qn_1;
            return qn_1;

        }
        else
            if (mo == "R134") {
                localQN = parseFloat(qn_1) * parseFloat(0.97);
                return parseFloat(qn_1) * parseFloat(0.97);
            }
            else
                if (mo == "R404a/R507a") {
                    localQN = parseFloat(qn_1) * parseFloat(1.05);
                    return parseFloat(qn_1) * parseFloat(1.05);
                }



    }

    function GetCondenser(paramcompanycond) {
        if (paramcompanycond != 0 && zarfiyatevaprator != 0 && zarfiyatevaprator != "-" && zarfiyatevaprator != "" && mobared != "" && mobared != "-" && mobared != 0 && selectcompresor != "-" && selectcompresor != "" && selectcompresor != 0) {
            setCondTempItems([]);
            fetch(`https://app.arshehkar.com/query/public/GetCondList.php?com=${selectcompresor}&cmpany=${paramcompanycond}&tc=${Math.floor(parseFloat(damayout) + ((parseFloat(-0.24) * parseFloat(damayout)) + 19))}&te=${parseFloat(te) >= parseFloat(-20) && parseFloat(te) <= parseFloat(-5) ? parseFloat(-5) : (parseFloat(te) >= parseFloat(-35) && parseFloat(te) < parseFloat(-20)) ? parseFloat(-20) : parseFloat(te) < parseFloat(-35) && parseFloat(te) > parseFloat(-45) ? parseFloat(-25) : parseFloat(te) > parseFloat(-5) ? parseFloat(te) : "-"}&model=${mobared}&zevap=${txtzarfiyatcondonsor}&otmp=${damayout}&brandcom=${brand}`)
                .then(response => response.json())
                .then(async (datacond) => {
                    const mapArray = datacond.map(({ model_title, zarfiyatnami }) => ({ label: model_title, value: zarfiyatnami }));
                    setCondTempItems(mapArray);
                    if (datacond.length > 0) {
                        setZarfiyatnamicond(datacond[0]["zarfiyatnami"]);
                        setSelLabelCondonsor(datacond[0]["model_title"]);
                        Setzaribetminancondonsor((((datacond[0]["zarfiyatnami"] * (parseFloat(-0.24) * parseFloat(damayout) + parseFloat(19))) / 15) / txtzarfiyatcondonsor).toFixed(2));
                    }
                    else {
                        setZarfiyatnamicond('-');
                        Setzaribetminancondonsor("-");
                    }

                })
        }
        else {
            setCondData(null);
            setZarfiyatnamicond("-");
            setCondTempItems([]);
            Setzaribetminancondonsor("-");

        }
    }

    function GetZarfiyatCondonsor(paramzarfiyatcondonsor, parammo) {

        if (paramzarfiyatcondonsor != "-" && parammo != "-") {
            fetch(`https://app.arshehkar.com/query/public/GetCondZarfiyat.php?com=${paramzarfiyatcondonsor}&model=${parammo}&brandcom=${brand}&te=${parseFloat(te) >= parseFloat(-20) && parseFloat(te) <= parseFloat(-5) ? parseFloat(-5) : (parseFloat(te) >= parseFloat(-35) && parseFloat(te) < parseFloat(-20)) ? parseFloat(-20) : parseFloat(te) < parseFloat(-35) && parseFloat(te) > parseFloat(-45) ? parseFloat(-25) : parseFloat(te) > parseFloat(-5) ? parseFloat(te) : "-"}&tc=${tc}`)
                .then(response => response.json())
                .then(async (responseJson) => {

                    setTxtzarfiyatcondonsor(responseJson);
                })
        }

    }


    return (

        <SafeAreaView style={styles.container}>
            {inprogsess === true ?
                <View style={styles.spinner}>
                    <ActivityIndicator size={90} color='#d12023' />
                </View>
                : null}
            <View style={styles.centeredView}>
                <Modal
                    animationType="slide"
                    transparent={true}
                    visible={modalVisible}
                    onRequestClose={() => {
                        Alert.alert("Modal has been closed.");
                        setModalVisible(!modalVisible);
                    }}
                >
                    <View style={styles.centeredView}>

                        <View style={styles.modalView}>
                            <View style={[{ flexDirection: 'row', alignItems: 'center' }]}>
                                <View
                                    style={{
                                        borderBottomWidth: 1,
                                        borderBottomColor: '#d12023',
                                        width: 100, flex: 1, height: 2
                                    }}
                                />
                                <View>
                                    <Text style={[styles.textStyle, { width: 50, textAlign: 'center', color: "#000" }]}>{t('error')}</Text>
                                </View>
                                <View
                                    style={{
                                        borderBottomWidth: 1,
                                        borderBottomColor: '#d12023',
                                        width: 100, flex: 1, height: 2
                                    }}
                                />
                            </View>
                            <Text style={styles.modalText}>{errorlist}</Text>
                            <TouchableOpacity
                                style={[styles.button, styles.buttonClose]}
                                onPress={() => setModalVisible(!modalVisible)}
                            >
                                <Text style={styles.textStyle}> {t('ok')} </Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </Modal>
            </View>

            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('generaldata')}</Text>
            </View>

            <View style={styles.form}>
                <Text style={styles.titleform}>C°</Text>
                <Text style={styles.titleform}>{damayotagh}</Text>
                <Text style={styles.titleform}>{t('roomtemperature')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>C°</Text>
                <Text style={styles.titleform}>{damayout}</Text>
                <Text style={styles.titleform}>{t('tempratureouts')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}></Text>
                <Text style={styles.titleform}>{shadat}</Text>
                <Text style={styles.titleform}>{t('ventilationlossfactor')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>day/h</Text>
                <Text style={styles.titleform}>{zamansystem}</Text>
                <Text style={styles.titleform}>{t('runningtimeinstallation')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>m</Text>
                <Text style={styles.titleform}>{tol} * {arz} * {ertefa}</Text>
                <Text style={styles.titleform}>{t('lengthwidthheight')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>m³</Text>
                <Text style={styles.titleform}>{tol * arz * ertefa}</Text>
                <Text style={styles.titleform}>{t('RoomVolume')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}></Text>
                <Text style={styles.titleform}>{ayegh}</Text>
                <Text style={styles.titleform}>{t('isolationmaterial')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>mm</Text>
                <Text style={styles.titleform}>{zekhamatdivar}</Text>
                <Text style={styles.titleform}>{t('isolationthicknessofwallsandfloor')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>mm</Text>
                <Text style={styles.titleform}>{zekhamatkaf}</Text>
                <Text style={styles.titleform}>{t('floorisolationthickness')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>W/m2K</Text>
                <Text style={styles.titleform}>{zaribhadayatayegh}</Text>
                <Text style={styles.titleform}>{t('k-valueisolationpanel')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>Watt / hrs/day</Text>
                <Text style={styles.titleform}>{tavanfan}</Text>
                <Text style={styles.titleform}>{t('fanspower')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>Watt/m^2 / hrs/day</Text>
                <Text style={styles.titleform}>{roshanaei}</Text>
                <Text style={styles.titleform}>{t('illumination')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}> hrs/day</Text>
                <Text style={styles.titleform}>{tedadkatgar}</Text>
                <Text style={styles.titleform}>{t('persons')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>Watt / hrs/day</Text>
                <Text style={styles.titleform}>{liftrag}</Text>
                <Text style={styles.titleform}>{t('forkliftsothers')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}></Text>
                <Text style={styles.titleform}>{mahsol}</Text>
                <Text style={styles.titleform}>{t('producttype')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>kg</Text>
                <Text style={styles.titleform}>{zarfiyatbargiri}</Text>
                <Text style={styles.titleform}>{t('storagequantity')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>kg</Text>
                <Text style={styles.titleform}>{zarfiyatbargirirozaneh}</Text>
                <Text style={styles.titleform}>{t('stockshift')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>C °</Text>
                <Text style={styles.titleform}>{damayvorodi}</Text>
                <Text style={styles.titleform}>{t('enteringtemperature')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>hr</Text>
                <Text style={styles.titleform}>{zamansardsazi}</Text>
                <Text style={styles.titleform}>{t('cooldowncongelationtime')}</Text>
            </View>


            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('loaddetails')}</Text>
            </View>

            <View style={styles.form}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{talafatjedareha}</Text>
                <Text style={styles.titleform}>{t('TransmissionLosses')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{talafathava.toFixed(3)}</Text>
                <Text style={styles.titleform}>{t('VentilationLosses')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{mabaghihararati}</Text>
                <Text style={styles.titleform}>{t('OtherHeatLosses')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{barsardsazi}</Text>
                <Text style={styles.titleform}>{t('CoolingDownLoad')}</Text>
            </View>
            <View style={styles.form}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{bartanafosi}</Text>
                <Text style={styles.titleform}>{t('RespirationLoad')}</Text>
            </View>
            <View style={styles.formodd}>
                <Text style={styles.titleform}>kw</Text>
                <Text style={styles.titleform}>{(parseFloat(talafatjedareha) + parseFloat(talafathava) + parseFloat(mabaghihararati) + parseFloat(barsardsazi) + parseFloat(bartanafosi)).toFixed(3)}</Text>
                <Text style={styles.titleform}>{t('total')}</Text>
            </View>
            <View style={[styles.form, { display: 'block', textAlign: 'center' }]}>
                <Text style={{ padding: 15, fontFamily: 'IranSans', color: '#d12023' }}>
                    {t("Part1Ans")} {zamansystem} {t("Part2Ans")} {qn} {t("KW")}
                </Text>
            </View>
            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{te} ℃</Text>
                <Text style={styles.titleform}>{t('Evaporatingtemperature')} (Te)</Text>
            </View>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{tc} ℃</Text>
                <Text style={styles.titleform}>{t('CondensingSDT')} (Tc)</Text>
            </View>



            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('Compressor')}</Text>
            </View>
            <Text style={styles.titlepicker}>{t('refrigerant')} <Text style={{ fontWeight: 'bold', color: 'red' }}>*</Text> </Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {


                    setMobared(itemValue);
                    GetMobared(brand, itemValue);
                    mohasebeQN(zarfiyatevaprator, itemValue, txttedadevaprator);





                }}
            >
                <Picker.Item label={t('selectyourrefrigerant')} value="0" />
                <Picker.Item label="R22" value="R22" />
                <Picker.Item label="R134" value="R134" />
                <Picker.Item label="R404a/R507a" value="R404a/R507a" />
            </Picker>

            <Text style={styles.titlepicker}>{t('compressorbrand')}</Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {
                    setBrand(itemValue);
                    GetMobared(itemValue, mobared);
                    mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator);

                }}

            >
                <Picker.Item label="Bitzer" value="1" />
                <Picker.Item label="Bock" value="2" />
            </Picker>





            <Text style={styles.titlepicker} > {t('Compressor')}  <Text style={{ fontWeight: 'bold', color: 'red' }}>*</Text></Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%', direction: 'rtl' }]}

                onValueChange={(itemValue, itemIndex) => {
                    setZarfiyatevaprator(itemValue);
                    setSelectCompresor(itemsMobaredTemp[itemIndex].label);
                    GetZarfiyatCondonsor(itemsMobaredTemp[itemIndex].label, mobared);
                    Setzaribetminancomprosor((itemValue / qn).toFixed(2));

                }}
            >
                {itemsMobaredTemp.map((item, index) => {
                    return (
                        <Picker.Item
                            key={index}
                            label={item.label}
                            value={item.value}
                        />
                    )
                }
                )
                }
            </Picker>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{zaribetminancomprosor}</Text>
                <Text style={styles.titleform}>{t('ComprossorSafetyFactor')}</Text>
            </View>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{zarfiyatevaprator}</Text>
                <Text style={styles.titleform}>{t('EvaporatorCapacity')}</Text>
            </View>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{txtzarfiyatcondonsor}</Text>
                <Text style={styles.titleform}>{t('CondenserCapacity')}</Text>
            </View>



            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('Evaporator')}</Text>
            </View>
            <Text style={styles.titlepicker}>{t('evaporatorrbrand')}</Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {
                    setSelectCompanyEvaprator(itemValue);
                    if (selectcompresor != "0" && selectcompresor != "-") {

                        mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator);
                        GetListEvaprator(itemValue, txttedadevaprator);
                    }
                    else {
                        SetErrorList(t('FirstSelectcompressorModel'));
                        setModalVisible(true);
                    }
                }}
            >
                <Picker.Item label={t('select')} value="0" />
                <Picker.Item label="ARSHEH" value="ARSHEH" />
                <Picker.Item label="ARTEC" value="ARTEC" />
            </Picker>

            <Text style={styles.titlepicker}> {t('Thenumberofevaporators')}</Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {
                    SetTxtTedadEvaprator(itemValue);
                    if (selectcompresor != "0" && selectcompresor != "-") {
                        mohasebeQN(zarfiyatevaprator, mobared, itemValue);
                        GetListEvaprator(selectcompanyevaprator, itemValue);
                    }
                    else {
                        SetErrorList(t('FirstSelectcompressorModel'));
                        setModalVisible(true);
                    }
                }}
            >
                <Picker.Item label="1" value="1" />
                <Picker.Item label="2" value="2" />
                <Picker.Item label="3" value="3" />
                <Picker.Item label="4" value="4" />
            </Picker>







            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>
                <TouchableOpacity
                    style={{ padding: 7 }}
                    onPress={() => props.navigation.navigate('SearchEvaprator', { TITLE: txtlabelevaprator, TYPE: 1 })}
                >
                    <Icon name={'search'} size={16} color={"#022a4c"} />
                    <Text style={{ fontFamily: 'IranSans', fontSize: 10, color: '#022a4c' }}>{t('evaporatorrSpecifications')}</Text>
                </TouchableOpacity>
                <View style={{ justifyContent: 'center' }}>
                    <Text style={{ fontSize: 14, fontFamily: 'IranSans', textAlign: 'right', padding: 7 }}>{t('Evaporator')}
                        <Text style={{ fontWeight: 'bold', color: 'red' }}>*</Text>
                    </Text>
                </View>
            </View>

            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {

                    setZarfiyatnami(itemValue);
                    SetTxtLabelEvaprator(itemsEvapTemp[itemIndex].label);
                    mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator);

                }}
            >
                {itemsEvapTemp.map((item, index) => {
                    return (
                        <Picker.Item
                            key={index}
                            label={item.label}
                            value={item.value}
                        />
                    )
                }
                )
                }
            </Picker>




            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{zarfiyatnami}</Text>
                <Text style={styles.titleform}>{t('evaporatorNominalcapacity')}</Text>
            </View>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{(zarfiyatnami / mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator)).toFixed(2)}</Text>
                <Text style={styles.titleform}>{t('evaporatorSafetyFactor')}</Text>
            </View>

            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{(zarfiyatevaprator * (zarfiyatnami / mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator))).toFixed(2)}</Text>
                <Text style={styles.titleform}>{t('evaporatorActualCapacity')}</Text>
            </View>

            <View style={styles.header}>
                <Text style={styles.titleheader}>{t('Condenser')}</Text>
            </View>
            <Text style={styles.titlepicker}> {t('Condenserbrand')}</Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={(itemValue, itemIndex) => {
                    if (selectcompresor != "0" && selectcompresor != "-") {
                        setSelectCompanyCond(itemValue);
                        GetCondenser(itemValue);

                    }
                    else {
                        SetErrorList(t('FirstSelectcompressorModel'));
                        setModalVisible(true);
                        Setzaribetminancondonsor("-");
                    }
                }}
            >
                <Picker.Item label={t('select')} value="0" />
                <Picker.Item label="ARSHEH" value="ARSHEH" />
                <Picker.Item label="ARTEC" value="ARTEC" />
            </Picker>
            <Text style={styles.titlepicker}>{t('Condenser')}  <Text style={{ fontWeight: 'bold', color: 'red' }}>*</Text></Text>
            <Picker
                mode="dropdown"
                style={[styles.dropdown, { width: '90%' }]}
                onValueChange={
                    (itemValue, itemIndex) => {
                        setZarfiyatnamicond(itemValue);
                        SetTxtLabelEvaprator(itemsCondTemp[itemIndex].label);
                        Setzaribetminancondonsor((((itemValue * (parseFloat(-0.24) * parseFloat(damayout) + parseFloat(19))) / 15) / txtzarfiyatcondonsor).toFixed(2));
                    }
                }
            >
                {itemsCondTemp.map((item, index) => {
                    return (
                        <Picker.Item
                            key={index}
                            label={item.label}
                            value={item.value}
                        />
                    )
                }
                )
                }
            </Picker>


            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{zaribetminancondonsor}</Text>
                <Text style={styles.titleform}>  {t('CondenserSafetyFactor')}</Text>
            </View>
            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{zarfiyatnamicond}</Text>
                <Text style={styles.titleform}>  {t('CondenserNominalcapacity')}</Text>
            </View>


            <View style={[styles.formodd, { backgroundColor: '#f0f4c3' }]}>
                <Text style={[styles.titleform, { fontWeight: 900, fontSize: 14 }]}>{((zarfiyatnamicond * (parseFloat(-0.24) * parseFloat(damayout) + parseFloat(19))) / 15).toFixed(2)}</Text>
                <Text style={styles.titleform}>  {t('CondenserActualCapacity')}</Text>
            </View>





            <ReactToPrint
                trigger={() => <button style={{ margin: 15, padding: '7px 40px', direction: 'rtl', fontFamily: 'IranSans', cursor: 'pointer   ', fontSize: 12.8, verticalAlign: 'center', background: '#08598e', color: '#fff', border: 'none', borderRadius: 7, display: 'inline-flex' }}><img src="https://app.arshehkar.com/gallery/icons/exortpdf.png" style={{ width: 45, paddingLeft: 10 }} /><p>{t('Exporttopdf')}</p></button>}
                content={() => componentRef.current}
            />
            <div style={{ display: "none" }}>
                <ComponentToPrint person={{
                    damayotagh: damayotagh,
                    ekhtelaf: damayout,
                    shadat: shadat,
                    zamansystem: zamansystem,
                    tae: tol + " * " + arz + " * " + ertefa,
                    hajm: tol * arz * ertefa,
                    ayegh: ayegh,
                    zekhamatdivar: zekhamatdivar,
                    zekhamatkaf: zekhamatkaf,
                    zaribhadayatayegh: zaribhadayatayegh,
                    tavanfan: tavanfan,
                    roshanaei: roshanaei,
                    tedadkatgar: tedadkatgar,
                    liftrag: liftrag,
                    mahsol: mahsol,
                    zarfiyatbargiri: zarfiyatbargiri,
                    zarfiyatbargirirozaneh: zarfiyatbargirirozaneh,
                    damayvorodi: damayvorodi,
                    zamansardsazi: zamansardsazi,
                    talafatjedareha: talafatjedareha,
                    talafathava: talafathava.toFixed(3),
                    mabaghihararati: mabaghihararati,
                    bartanafosi: bartanafosi,
                    majmo: parseFloat(talafatjedareha) + parseFloat(talafathava) + parseFloat(mabaghihararati) + parseFloat(barsardsazi) + parseFloat(bartanafosi),
                    te: te,
                    tc: tc,
                    qn: qn,
                    mobared: mobared,
                    brand: brand,
                    selectcompresor: selectcompresor,
                    zarfiyatevaprator: zarfiyatevaprator,
                    selectcompanyevaprator: selectcompanyevaprator,
                    txttedadevaprator: txttedadevaprator,
                    txtlabelevaprator: txtlabelevaprator,
                    zarfiyatkarbordievaprator: (zarfiyatevaprator * (zarfiyatnami / mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator))).toFixed(2),
                    zaribetminanevaprator: (zarfiyatnami / mohasebeQN(zarfiyatevaprator, mobared, txttedadevaprator)).toFixed(2),
                    zarfiyatnami: zarfiyatnami,
                    selectcompanycond: selectcompanycond,
                    sellabelcondonsor: sellabelcondonsor,
                    zarfiyatnamicond: zarfiyatnamicond,
                    zarfiyatkarbordicondonsor: ((zarfiyatnamicond * (parseFloat(-0.24) * parseFloat(damayout) + parseFloat(19))) / 15).toFixed(2),
                    barsardsazi: barsardsazi,
                }} ref={componentRef} />
            </div>
            <ScrollToTop smoth style={{ position: 'sticky', right: 0, bottom: 0, backgroundColor: 'gray' }} />


        </SafeAreaView>

    )
}

export default ResultBorodatiSimple;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        flex: 1,
        textAlign: 'center'
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',

        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',
        padding: 10,



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    formodd: {
        width: '90%',
        backgroundColor: '#e6e6e6',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    }
    ,
    header: {
        width: '90%',
        backgroundColor: '#022a4c',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    titleheader: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 14,
        flex: 1,
        textAlign: 'center',
        color: 'white'
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',

    }
    ,
    titlepicker: {
        fontSize: 14, fontFamily: 'IranSans', width: '90%', textAlign: 'right', padding: 7
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10
    },
    modalView: {
        margin: 10,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 15,
        width: '75%',
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    buttonOpen: {
        backgroundColor: "#F194FF",
    },
    buttonClose: {
        backgroundColor: "#06619b",
    },
    textStyle: {
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        fontFamily: 'IranSans',
        fontSize: 14.1

    },
    modalText: {
        marginBottom: 10,
        textAlign: "center", fontFamily: 'IranSans', fontSize: 13.5,
    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'black',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
        opacity: 0.5,
    }
});